import { STATUS } from "@/constant/statusConstants";

export const getRefreshScheduleInitialValues = (showData) => {
  const time = showData?.data?.time || "";
  const [hour, minute] = time.split(":");

  return {
    hour: hour || "",
    minute: minute || "",
    status: showData?.data?.status || STATUS.INACTIVE,
  };
};
